import React from 'react';

import { useStaticQuery, graphql } from 'gatsby';
import NonStretchedImage from '../NonStretchedImage/NonStretchedImage'

import './style.css';

const Afiliate = () => {

  const result = useStaticQuery(
    graphql`
      {
        file(relativePath: { eq: "afiliate.png" }) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  return (
    <div className="max-w-7xl mx-auto md:flex md:justify-around md:items-center h-full">
      <div className="mb-8 md:mb-0 md:w-1/3">
        <h2 className="text-gray-700 text-3xl text-center mb-4 md:text-left md:text-4xl">Afíliate a <span className="text-green-300">Fondimex</span></h2>
        <ul className="text-gray-700 leading-loose text-lg">
          <li className="flex items-center mb-4">
            <span  className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">1</span><span>Llena el formulario de aplicación</span>
          </li>
          <li className="flex items-center mb-4">
            <span className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">2</span><span>Envía la documentación</span>
          </li>
          <li className="flex items-center mb-4">
            <span className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">3</span><span>Fondea tu cuenta</span>
          </li>
          <li className="flex items-center mb-4">
            <span className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">4</span><span>Elige una factura del market</span>
          </li>
          <li className="flex items-center">
            <span className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">5</span><span>Recibe tus rendimientos</span>
          </li>
        </ul>
      </div>
      <NonStretchedImage
        className="mb-8 md:mb-0 md:w-1/2 image"
        fluid={result.file.childImageSharp.fluid}
        alt="Afiliate a Fondimex"
      />
    </div>
  );
}

export default Afiliate;